export default __webpack_public_path__ + "static/media/slurpy.b448c72c.avif";